/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import './css/HotelPhotoSwiper.css';

function HotelPhotoSwiper(props) {
  const { images } = props;
  const swipeRef = useRef();

  const slideLeft = () => {
    if (swipeRef.current) {
      swipeRef.current.slideNext();
    }
  };

  const slideRight = () => {
    if (swipeRef.current) {
      swipeRef.current.slidePrev();
    }
  };

  return (
    <div className="hp_w">
      <button
        type="button"
        className="hp_swipe_button_left"
        onClick={() => slideRight()}
      ></button>
      <div className="hp_w_swiper_w">
        <Swiper
          modules={[Pagination, Scrollbar, A11y]}
          spaceBetween={0}
          onSwiper={(swiper) => {
            swipeRef.current = swiper;
          }}
          observer
          observeParents
          slidesPerView={1}
          pagination={{ clickable: true, type: 'fraction' }}
        >
          {images.map((image, index) => {
            const id = `image-${index}`;
            const url = `https:${image}`;

            return (
              <SwiperSlide key={id}>
                <div className="hp_swiper_item">
                  <div className="hp_hotel_pic_w">
                    <img alt="" className="hp_hotel_pic" src={url} />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <button
        type="button"
        className="hp_swipe_button_right"
        onClick={() => slideLeft()}
      ></button>
    </div>
  );
}

HotelPhotoSwiper.propTypes = {
  images: PropTypes.instanceOf(Array).isRequired,
};

export default HotelPhotoSwiper;
